import ColorStyles from '@components/ColorStyles';
import BrDropdownMultiSelectMenuV2 from './BrDropdownMultiSelectMenuV2';

BrDropdownMultiSelectMenuV2.ColorStyles = ColorStyles;
export default BrDropdownMultiSelectMenuV2;
